let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a4ZTh")).then(() => parcelRequire('1O53N'));